import { render } from "./CardSocial.vue?vue&type=template&id=8c27bbb4"
import script from "./CardSocial.vue?vue&type=script&lang=js"
export * from "./CardSocial.vue?vue&type=script&lang=js"

import "./CardSocial.vue?vue&type=style&index=0&id=8c27bbb4&lang=css"
script.render = render

export default script